import SearchIcon from '@mui/icons-material/Search';
import {
    Box,
    Button,
    Dialog,
    IconButton,
    OutlinedInput,
    Typography
} from '@mui/material';
import map from "lodash/map";
import trim from "lodash/trim";
import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';

import CloseIcon from '@mui/icons-material/Close';
import get from "lodash/get";
import { useDispatch, useSelector } from "react-redux";
import Question from '../../../components/form/Question';
import Table from "../../../components/form/Table";
import AddIcon from '@mui/icons-material/Add';

import { addTemporalData } from "../../../store/transactions/thunk/addTemporalDP/add";

const Alert = ({
    __,
    open,
    close,
    reload,
    setError,
    callbackNewPoints, 
    points
}) => {
    const dispatch = useDispatch();
    const [selected, setSelected] = useState({})
    const [searchValue, setSearchValue] = useState("");
    const { id } = useParams();
    const [openQuestion, setOpenQuestion] = useState({
        value: "",
        state: false
    });
    const onChange = (e) => {
        setSearchValue(trim(e.target.value))
    }

    const current = selected
    const currentRoute = useSelector((state) => state.transactions.route.detail);
    const post = useSelector(state => state.transactions.route.postCost);
    const user = useSelector(state => state.auth.login.dataUser);
    const customerId = get(currentRoute, "data.customerId");
    const paymentClient = useSelector(state => state.transactions.paymentClient)
    const temporalDP = useSelector(state => state.transactions.addTemporalDP);
    const deliveryPointRoute = useSelector(state => state.transactions.deliveryPointRoute);

    //Saber el ultimo ordering
    const maxOrdering = temporalDP.data.length > 0
        ? Math.max(...temporalDP.data.map(item => item.ordering))
        : 0;

    const newOrdering = maxOrdering + 1;

    const isDeliveryPointAdded = (idDeliveryPoint) => {
        return temporalDP.data.some(item => item.idDeliveryPoint === idDeliveryPoint);
    };

    const onCloseModal = (r) => {
        setSelected({})
        close()
        if (r === "1") {
            reload()
        }
    }

    useEffect(() => {
        if (get(post, "isSuccess", false)) { onCloseModal("1") }
        if (get(post, "isReject", false)) { setError(get(post, "error", {}), "post") }
    }, [post])

    const onAdd = () => {
        const maxOrdering = Math.max(...points.map(item => item.ordering), 0);
        let newOrdering = maxOrdering + 1; 
        let date = points[0].deliveryDate;
        let point = [{ 
            ...openQuestion.value, 
            canDelete: true,
            ordering: newOrdering,
            deliveryDate: date
        }];
        
        callbackNewPoints(point);
        setOpenQuestion(prev => ({ ...prev, state: false }))
        close();
    }

    const headTable = [
        {
            key: "Button",
            label: "Seleccionado",
            align: "center",
            width: 70,
        },
        {
            key: "deliveryName",
            label: __(`table.colsDP.deliveryName`),
            align: "center"
        },
        {
            key: "municipality",
            label: __(`table.colsDP.municipality`),
            align: "center"
        },
        {
            key: "state",
            label: __(`table.colsDP.state`),
            align: "center"
        }
    ]

    const dataTable = map(get(deliveryPointRoute, "data", []), (row, i) => {
        const labelId = `enhanced-table-checkbox-${i}`;
        const isDisabled = isDeliveryPointAdded(row.idDeliveryPoint);

        return ({
            ...row,
            Button: (
                <Button
                    name="btnDeliveryPoint"
                    onClick={() => { setOpenQuestion(prev => ({ ...prev, state: true, value: row })) }}
                    inputProps={{ 'aria-labelledby': labelId }}
                    variant="contained"
                    color="primary"
                    startIcon={<AddIcon/>}
                    disabled={isDisabled}  // Deshabilitar si hay un "match"
                >
                    {isDisabled ? "Agregado" : "Agregar"}
                </Button>
            ),
        })
    })


    return (
        <Dialog close={close} open={open} maxWidth="lg" fullWidth>
            <Box>
                <IconButton
                    aria-label="close"
                    onClick={close}
                    sx={{
                        position: 'absolute',
                        right: 8,
                        top: 8,
                        color: (theme) => theme.palette.grey[500],
                    }}
                >
                    <CloseIcon />
                </IconButton>
            </Box>
            <Box className='px-6'>
                <Typography variant="h6" sx={{ mt: 2, mb: 1 }}>
                    {__(`labels.15`)}
                </Typography>
            </Box>
            <Box className='flex flex-col justify-center m-6'>
                <div className='px-8 pyt-2'>
                    <OutlinedInput
                        id="search-btn"
                        endAdornment={
                            <IconButton type="button" sx={{ p: '10px' }} aria-label="search">
                                <SearchIcon />
                            </IconButton>
                        }
                        aria-describedby="outlined-weight-helper-text"
                        inputProps={{
                            'aria-label': 'weight',
                        }}
                        size="small"
                        fullWidth
                        onChange={onChange}
                        placeholder={__("action.search")}
                    />
                </div>
                <div className='px-8 pyt-2 pt-3'>
                    <Table headTable={headTable}
                        dataTable={dataTable}
                        __={__}
                        sizeFilters={125}
                        empty="deliveryPoints"
                    />
                </div>
                <Question
                    title={__("alert.addDeliveryPoint")}
                    detail={__("alert.addDeliveryPointDetail")}
                    onSuccess={onAdd}
                    onCancel={() => setOpenQuestion(prev => ({ ...prev, state: false }))}
                    open={openQuestion.state}
                />
            </Box>
        </Dialog>
    );
}

export default Alert